import { SVGProps, Ref, forwardRef } from 'react';

export const CardLinesCrossFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M.5 8c0-6.125.938-7 7.5-7s7.5.875 7.5 7q0 .453-.007.87a4.733 4.733 0 0 0-6.946 6.129L8 14.999C1.438 15 .5 14.125.5 8M4 6.034v-1.4h8v1.4zM8 8.7H4V7.3h4z"
                    fill="currentColor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.667 16a3.333 3.333 0 1 0 0-6.667 3.333 3.333 0 0 0 0 6.667m-2.05-4.388 1.058 1.058-1.058 1.059.99.99 1.058-1.059 1.064 1.063.99-.99-1.064-1.063 1.064-1.063-.99-.99-1.064 1.063-1.058-1.058z"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
CardLinesCrossFilledSize16Glyph.displayName = 'CardLinesCrossFilledSize16Glyph';
